import { render, staticRenderFns } from "./VueInstagram.vue?vue&type=template&id=295cef79&"
import script from "./VueInstagram.vue?vue&type=script&lang=js&"
export * from "./VueInstagram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports